import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.group.user');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router'

@Component({
    selector: 'wiz-portal-gsdcadmin-community-group-user',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.group.user/view.scss */
.ac-member-mail-notices {
  list-style: none;
  padding: 12px 16px;
  margin: 12px 0;
  border: 1px solid #d4a650;
  border-radius: 8px;
  font-size: 13px;
}

.ac-member-mail-notices li + li {
  margin-top: 10px;
}

.ac-member-mail-notices strong, .ac-member-mail-notices span {
  display: block;
}`],
})
export class PortalGsdcadminCommunityGroupUserComponent implements OnInit, OnDestroy {

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() community_id: any;
    @Input() group_id: any;
    public users: any = [];
    public community: any = {};
    public group: any = {};

    public pagination: any = {
        page: 1,
        start: 1,
        end: 1
    }
    public searchTerm = "";
    public total = 0;
    public canAddMembers = false;
    @ViewChild('memberDialog') memberDialog!: ElementRef<HTMLDialogElement>;
    public candidates: any[] = [];
    public candidateText = '';
    public candidatePage = 1;
    public candidatePages = 1;
    public candidateTotal = 0;
    public candidatesLoading = false;
    public candidateError = '';
    public selected: { [id: string]: any } = {};
    public adding = false;
    public processed = 0;
    public batchTotal = 0;
    public added = 0;
    public failures: any[] = [];
    public mailNotices: any[] = [];
    private candidateVersion = 0;
    private searchTimer: any;
    private destroyed = false;
    private additionContext: any = {};

    public get selectedUsers(): any[] { return Object.values(this.selected); }

    public async openMembers() {
        if (this.adding) return;
        this.additionContext = {group_id: this.group_id, community_id: this.community_id};
        this.selected = {}; this.failures = []; this.mailNotices = []; this.added = 0;
        this.candidateText = ''; this.candidates = []; this.candidateError = '';
        await this.service.render();
        this.memberDialog.nativeElement.showModal();
        await this.loadCandidates(1);
    }

    public closeMembers(event?: Event) {
        event?.preventDefault();
        if (this.adding) return;
        clearTimeout(this.searchTimer);
        this.candidateVersion++;
        this.memberDialog.nativeElement.close();
    }

    public backdropMembers(event: MouseEvent) {
        if (event.target === this.memberDialog.nativeElement) this.closeMembers();
    }

    public async searchCandidates() {
        if (this.adding) return;
        clearTimeout(this.searchTimer);
        this.candidateVersion++;
        this.candidates = []; this.candidatesLoading = true; this.candidateError = '';
        await this.service.render();
        this.searchTimer = setTimeout(() => this.loadCandidates(1), 250);
    }

    public async loadCandidates(page = 1) {
        clearTimeout(this.searchTimer);
        const version = ++this.candidateVersion;
        this.candidatesLoading = true; this.candidateError = ''; this.candidates = [];
        await this.service.render();
        const response = await wiz.call('member_candidates', {
            ...this.additionContext,
            text: this.candidateText, page
        }).catch(() => null);
        if (this.destroyed || version !== this.candidateVersion) return;
        this.candidatesLoading = false;
        if (response?.code !== 200) {
            this.candidateError = response?.data?.message || '목록을 불러오지 못했습니다. 다시 시도해주세요.';
        } else {
            this.candidates = response.data.rows;
            this.candidateTotal = response.data.total;
            this.candidatePage = response.data.page;
            this.candidatePages = response.data.lastpage;
        }
        await this.service.render();
    }

    public async selectMember(user: any) {
        if (this.adding) return;
        if (this.selected[user.id]) delete this.selected[user.id];
        else this.selected[user.id] = user;
        await this.service.render();
    }

    public async addMembers() {
        const batch = this.selectedUsers;
        if (this.adding || !batch.length || this.candidatesLoading) return;
        this.adding = true; this.failures = []; this.mailNotices = []; this.added = 0;
        this.processed = 0; this.batchTotal = batch.length;
        this.candidateVersion++;
        clearTimeout(this.searchTimer);
        await this.service.render();
        try {
            for (const user of batch) {
                if (this.destroyed) break;
                const response = await wiz.call('add_member', {
                    ...this.additionContext, user_id: user.id
                }).catch(() => null);
                if (response?.code === 200) {
                    delete this.selected[user.id];
                    this.added++;
                    const status = response.data?.notification_status;
                    if (status && !['sent', 'no_recipients'].includes(status)) {
                        this.mailNotices.push({user, message: response.data.message ||
                            '구성원 추가는 완료되었습니다. 안내 메일 발송 상태를 확인해주세요.'});
                    }
                } else {
                    this.failures.push({user, message: response?.data?.message ||
                        '처리 결과를 확인하지 못했습니다. 같은 사용자로 다시 시도해주세요.'});
                }
                this.processed++;
                if (!this.destroyed) await this.service.render();
                // A revoked session/permission must stop the rest of the batch.
                if ([401, 403].includes(response?.code)) break;
            }
        } finally {
            this.adding = false;
            if (!this.destroyed) {
                await this.service.render();
                await this.load(true);
                await this.loadCandidates(this.candidatePage);
            }
        }
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.candidateVersion++;
        clearTimeout(this.searchTimer);
        this.memberDialog?.nativeElement.close();
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load(quiet = false) {
        const response = await wiz.call("load", { text: this.searchTerm, page: this.pagination.page, communityID: this.community_id, groupID: this.group_id }).catch(() => null);
        if (this.destroyed) return;
        if (response?.code !== 200) {
            if (!quiet) await this.service.alert.error("목록을 불러오지 못했습니다. 다시 시도해주세요.");
            return;
        }
        const data = response.data;
        this.canAddMembers = data.can_add_members === true;
        this.users = data.users;
        this.community = data.community;
        this.group = data.group;
        this.pagination.page = data.page || this.pagination.page;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        await this.service.render();
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.load();
    }

    public async changePI(user: any, event: Event) {
        const checkbox = event.target as HTMLInputElement;

        const original = user.representative;              // 'Y' 또는 'N' (기존 상태)
        const next = checkbox.checked ? 'Y' : 'N';         // 클릭 후 상태

        // UI에 먼저 반영
        user.representative = next;
        await this.service.render();

        let res: any;
        if (next === 'Y') {
            res = await this.service.alert.show({
                title: "PI 지정",
                message: "해당 사용자를 PI로 지정하시겠습니까?",
                action: "지정",
                cancel: "취소",
                actionBtn: 'success',
                status: 'success'
            });
        } else {
            res = await this.service.alert.show({
                title: "PI 해제",
                message: "해당 사용자를 PI에서 해제하시겠습니까?",
                action: "해제",
                cancel: "취소",
                actionBtn: 'error',
                status: 'error'
            });
        }

        // 취소 눌렀을 때 → 원복
        if (res !== true) {
            user.representative = original;
            await this.service.render();
            return;
        }

        // 서버 호출
        const response: any = await wiz.call("changePI", {
            user: JSON.stringify(user),
            group: JSON.stringify(this.group)
        }).catch(() => null);

        // 실패 시에도 원복
        if (response?.code !== 200) {
            user.representative = original;
            await this.service.render();
            return await this.service.alert.error(response?.data?.message || "PI 지정/해제에 실패했습니다. 다시 시도해주세요.");
        }

        await this.service.alert.success(response.data?.message || "PI 지정/해제 완료했습니다.");
    }
}

export default PortalGsdcadminCommunityGroupUserComponent;